import { marketingKitSearchValidator } from "@/validators/marketing-kit";
import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";

export const Route = createFileRoute("/_app/marketing-kit/")({
  validateSearch: zodValidator(marketingKitSearchValidator),
  loaderDeps: ({ search }) => search,
});
